module.exports = "/assets/a21d0dffa6e4f2cfedb8b44ddb82a85d.png";